import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import HighwayUnpaidSearchForm from '@di-shared/features/public-service/highway-unpaid/HighwayUnpaidSearchForm';

export interface HighwayUnpaidSearchPageProps {
  vin: string;
}

function HighwayUnpaidSearchPage({vin}: HighwayUnpaidSearchPageProps) {
  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">고속도로 미납통행료 조회</h1>
      </Header>

      <HighwayUnpaidSearchForm vin={vin} />
    </div>
  );
}

export default HighwayUnpaidSearchPage;
